// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1o1ap","footer":"styles_footer__yPSWA","passCodeTooltip":"styles_passCodeTooltip__9xiqm"};